// Copyright (c) 2017 Deere & Company

import AllClaims, {getDefaultState} from '../state/all-claims';
import actions from '../../action-list';

const updateAllClaims = (state, action) =>
    AllClaims.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_ALL_CLAIM_SEARCH_RESULTS_SUCCESS]: updateAllClaims
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/all-claims/reducers/all-claims.js